import $x from '@/utils/$x';

/// 帕加马-续费签约列表
export async function renewAgreementList(params) {
  return $x.post('/renew/agreement/list', params);
}

/// 帕加马-续费签约记录
export async function renewAgreementRecords(params) {
  return $x.post('/renew/agreement/records', params);
}

/// 保存暂停扣费记录
export async function saveRenewAgreementSuspended(params) {
  return $x.post('/renew/saveRenewAgreementSuspended', params);
}

/// 暂停信息列表
export async function queryRenewAgreementSuspendedList(params) {
  return $x.post('/renew/queryRenewAgreementSuspendedList', params);
}

/// 暂停扣费失效操作 I
export async function invalidRenewAgreementSuspended(params) {
  return $x.post('/renew/invalidRenewAgreementSuspended', params);
}

/// 返回签约商品信息
export async function queryRenewAgreementGoods(params) {
  return $x.post('/renew/queryRenewAgreementGoods', params);
}

/// 保存签约商品信息
export async function saveRenewAgreementGoods(params) {
  return $x.post('/renew/saveRenewAgreementGoods', params);
}

/// 删除签约商品
export async function deleteRenewAgreementGoods(params) {
  return $x.post('/renew/deleteRenewAgreementGoods', params);
}

/// 帕加马-续费开关变更 ID：nzDGm3yX
export async function renewAgreementUpdate(params) {
  return $x.post('/renew/agreement/config/update', params);
}
